module.exports = __webpack_public_path__ + "static/media/yt.0e14f827.svg";